import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col, Card, CardHeader, CardBody, Button, Badge } from "shards-react";

import PageTitle from "../components/common/PageTitle";
import { Store } from "../flux";

const Apps = () => {

    const [ AppsData, SetAppsData ] = useState([]);

    useEffect(() => {

        const getData = async () => {

            const Apps = Store.getApps();

            if (!Apps.length) {

                await Store.retrieveApps();
                await SetAppsData(Store.getApps());
            } else {

                SetAppsData(Store.getApps());
            }
        }

        getData();
    }, [ Store.getApps() ]);

    const addApp = () => {

        alert("Contact Mobile admin.");
    }

    return (
        <Container fluid className="main-content-container px-4">

            {/* Page Header */}
            <Row noGutters className="page-header py-4">

                <Col className="col-6">
                    <PageTitle sm="6" title="View" subtitle="Apps" className="text-sm-left" />
                </Col>
                <Col className="col-6">
                    <Button className="float-right" onClick={ addApp }>
                        <i className="material-icons">add</i>&nbsp;&nbsp;Add new App
                    </Button>
                </Col>
            </Row>
            <Row>
                { AppsData.map((App, Index) => {

                    return (

                        <Col lg="4" md="8" sm="12" className="mb-4" key={ Index }>
                            <Card small className="card-post card-post--1" style={{ height: "", cursor: "pointer" }}>
                                <CardBody>
                                    <a href="#" className="card-post__author-avatar card-post__author-avatar--small" style={{ padding: "1.5rem", backgroundColor: "white", marginTop: "-1rem", marginBottom: "1rem", backgroundImage: `url('${ App.app_icon_url }')` }} />

                                    <Link to={{ pathname: `/apps/${ App.unique_app_name }`, state: { AppDetails: App } }} >
                                        <Badge pill className={`card-post__category bg-royal-blue`} style={{ marginTop: "0.85rem" }}><i className="material-icons">edit</i>&nbsp;&nbsp;edit</Badge>
                                    </Link>
                                    <h5 className="card-title">
                                        <a href="#" className="text-fiord-blue">{ App.name }</a>
                                    </h5>
                                    <hr />
                                    <p className="card-text d-inline-block mb-3">{ App.description }</p>
                                    <br />
                                    <span className="text-muted center">
                                        <a href={ App.ios_url } target="_blank">
                                            <Button className="btn-primary">IOS Store&nbsp;&nbsp;<i className="material-icons mr-1">trending_flat</i></Button>
                                        </a>
                                        &nbsp;&nbsp;
                                        <a href={ App.android_url } target="_blank">
                                            <Button className="btn-primary">Android Store&nbsp;&nbsp;<i className="material-icons mr-1">trending_flat</i></Button>
                                        </a>
                                    </span>
                                </CardBody>
                            </Card>
                        </Col>
                    );
                })}
            </Row>
        </Container>
    );
}

export default Apps;
